import React from "react";
import { H1, H2, H3, H4, H5, H6 } from "../../lib/src";
import * as scss from "./docs-heading.scss";

export type HeadingProps = {
	children: string;
	id?: string;
};

function makeHeader(Heading: typeof H1) {
	return (props: HeadingProps) => {
		const id = props.id ?? props.children.toLocaleLowerCase().replace(/ /g, "-");
		return (
			<Heading id={id}>
				<a className={scss.a} href={`#${id}`}>
					<span className={scss.hashtag}>#</span>
					{props.children}
				</a>
			</Heading>
		);
	};
}

export const Header = {
	H1: makeHeader(H1),
	H2: makeHeader(H2),
	H3: makeHeader(H3),
	H4: makeHeader(H4),
	H5: makeHeader(H5),
	H6: makeHeader(H6),
} as const;
